import { msalInstance } from "@/auth.js";

const ADO_SCOPE = ["499b84ac-1321-427f-aa17-267ca6975798/user_impersonation"];
const ENTRA_API_SCOPE = [process.env.VUE_APP_ENTRA_API_SCOPE || "api://148fb37f-b23c-4a29-b5fc-0940a924bb53/access_as_user"];

/**
 * Acquires an access token for Azure DevOps APIs.
 * Used by pipeline, capture, and baseline components.
 * Throws if no authenticated account is found.
 * @returns {Promise<string>} The access token
 */
export async function getAccessToken() {
  const accounts = msalInstance.getAllAccounts();
  if (!accounts || !accounts.length) {
    throw new Error("User is not logged in");
  }

  const response = await msalInstance.acquireTokenSilent({
    account: accounts[0],
    scopes: ADO_SCOPE,
  });

  return response.accessToken;
}

/**
 * Acquires an access token for the Cyanic Entra backend API.
 * Used by entra-api.js and EntraReports.vue.
 * Throws if no authenticated account is found.
 * @returns {Promise<string>} The access token
 */
export async function getEntraApiAccessToken() {
  const accounts = msalInstance.getAllAccounts();
  if (!accounts || !accounts.length) {
    throw new Error("User is not logged in");
  }

  const response = await msalInstance.acquireTokenSilent({
    account: accounts[0],
    scopes: ENTRA_API_SCOPE,
  });

  return response.accessToken;
}
